import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { TextField, Box, Button, useTheme } from '@material-ui/core';
import ReplayIcon from '@material-ui/icons/Replay';
import SearchIcon from '@material-ui/icons/Search';
import { useIntl } from 'umi';
import DataTableNativeML from '@/components/DataTableNativeML';
import request from '@/utils/request';
import DepartmentModalStyled from './DepartmentModalStyled';

export default (props) => {
  //关于国际化
  const intl = useIntl();
  const { formatMessage } = intl;
  const theme = useTheme();
  const [isRefresh, setIsRefresh] = useState(0);
  const [isSearch, setIsSearch] = useState(false);
  const {
    setOpen = () => {},
    onConfirm,
    chooseList,
    showType,
    setChooseList,
  } = props;

  const [pageData, setPageData] = useState({
    pageSize: 8,
    pageNum: 1,
  });

  const chooseIdList = useMemo(() => {
    return chooseList?.map((i) => (showType !== '2' ? i.id : i.proNo));
  }, [chooseList]);

  const [title, setTitle] = useState('');

  const fetchList = useCallback(() => {
    request('/coupon/dep/query/page', {
      method: 'POST',
      data: {
        pageNum: pageData.pageNum,
        pageSize: pageData.pageSize,
        depName: isSearch ? title : null,
      },
    }).then((res) => {
      setCpList(res.data.data);
      setTotal(res.data.total);
      setPages(res.data.pages);
    });
  }, [pageData, isRefresh]);

  useEffect(() => {
    fetchList();
  }, [fetchList]);

  const [cpList, setCpList] = useState([]);
  const [total, setTotal] = useState(0);
  const [pages, setPages] = useState(0);
  const columns = [
    {
      type: 'checkbox',
      width: 80,
      onChange: (a, b, c) => {
        const data = [...chooseList, ...c];
        let chooseArr = [];
        data.forEach((item) => {
          const findItem = chooseArr.some((it) => item.id === it.id);
          if (a.includes(item.id) && !findItem) {
            chooseArr.push(item);
          }
        });
        setChooseList(chooseArr);
      },
    },
    {
      align: 'center',
      title: '部门编号',
      id: 'id',
      key: 'id',
      width: 180,
    },
    {
      align: 'center',
      title: '部门名称',
      id: 'depName',
      key: 'depName',
      width: 180,
    },
    {
      align: 'center',
      title: '部门人数',
      id: 'count',
      key: 'count',
      width: 220,
    },
  ];

  //换页
  const changePage = (obj) => {
    setPageData({ ...pageData, ...obj });
  };

  const handleClose = () => {
    setOpen(false);
  };

  const onSubmit = () => {
    onConfirm(chooseList);
    setOpen(false);
  };

  const footContent = (
    <div className="modal-btn-wrap">
      <Button onClick={handleClose} variant="contained" color="secondary">
        {formatMessage({ id: 'comm.action.btn.08' })}
      </Button>
      <Button
        variant="contained"
        type="submit"
        className="btnSubmit button"
        onClick={onSubmit}
      >
        {formatMessage({ id: 'comm.action.btn.07' })}
      </Button>
    </div>
  );
  const handleRestClick = () => {
    setIsSearch(false);
    setTitle('');
    setPageData({ ...pageData, pageNum: 1 });
    setIsRefresh(isRefresh + 1);
  };
  return (
    <DepartmentModalStyled theme={theme}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          padding: '0 32px',
        }}
      >
        <Box className="coupon-name-wrap">
          <Box sx={{ color: '#212121', fontSize: '18px', fontWeight: '600' }}>
            选择部门
          </Box>
          <TextField
            className="coupon-name"
            variant="standard"
            onChange={(e) => {
              setTitle(e.target.value);
              setIsSearch(false);
            }}
            value={title}
            label="部门名称"
            placeholder="请输入部门名称"
          />
          <div></div>
        </Box>
        <Box
          className="button-group"
          sx={{
            display: 'flex',
            gap: '6px',
            flexShrink: 0,
          }}
        >
          <Button
            variant="contained"
            color="secondary"
            className="reset"
            onClick={handleRestClick}
            startIcon={<ReplayIcon sx={{ width: '16px', height: '16px' }} />}
          >
            {formatMessage({ id: 'comm.action.btn.06' })}
          </Button>

          <Button
            variant="contained"
            className="search"
            startIcon={<SearchIcon sx={{ width: '16px', height: '16px' }} />}
            onClick={() => {
              setPageData({ ...pageData, pageNum: 1 });
              setIsRefresh(isRefresh + 1);
              setIsSearch(true);
            }}
          >
            {formatMessage({ id: 'comm.action.btn.01' })}
          </Button>
        </Box>
      </Box>
      <div className="coupon-list">
        <DataTableNativeML
          columns={columns}
          changePage={changePage}
          page={pageData}
          data={cpList}
          total={total}
          devicesMinWidth="auto"
          chooseIds={chooseIdList}
          paging={true}
          columnKey="id"
          FootContent={footContent}
          initP={true}
          hasNext={pageData.pageNum < pages}
          showPagingData={{ status: true, marginTop: '24px' }}
          showPageColor={true}
          pages={pages}
          np={true}
        ></DataTableNativeML>
      </div>
    </DepartmentModalStyled>
  );
};
